<template>
    <div class="bg-yellow-600 opacity-50 text-sm text-center rounded p-2 py-1">
        <div class="">
            <div v-if="message.content.stub && stubs[message.content.stub]">
                {{ getStub(message.content.stub) }}
            </div>
            <div v-else-if="message.content.stub">
                {{ $t("stubs_" + message.content.stub.toLowerCase()).replace('stubs_', '').replaceAll('_', ' ') }}
            </div>
            <div v-else>
                {{ message.content }}
            </div>
        </div>
    </div>
</template>

<style>
    .stub {
        font-size: 10px;
    }
</style>

<script>
    export default {
        props: {
            message: Object
        },

        mounted() {
            this.stubs = {
                '0': 'unknown',
                '1': 'revoked',
                '2': 'CIPHERTEXT',
                '3': 'FUTUREPROOF',
                '4': 'NON_VERIFIED_TRANSITION',
                '5': 'UNVERIFIED_TRANSITION',
                '6': 'VERIFIED_TRANSITION',
                '7': 'VERIFIED_LOW_UNKNOWN',
                '8': 'VERIFIED_HIGH',
                '9': 'VERIFIED_INITIAL_UNKNOWN',
                '10': 'VERIFIED_INITIAL_LOW',
                '11': 'VERIFIED_INITIAL_HIGH',
                '12': 'VERIFIED_TRANSITION_ANY_TO_NONE',
                '13': 'VERIFIED_TRANSITION_ANY_TO_HIGH',
                '14': 'VERIFIED_TRANSITION_HIGH_TO_LOW',
                '15': 'VERIFIED_TRANSITION_HIGH_TO_UNKNOWN',
                '16': 'VERIFIED_TRANSITION_UNKNOWN_TO_LOW',
                '17': 'VERIFIED_TRANSITION_LOW_TO_UNKNOWN',
                '18': 'VERIFIED_TRANSITION_NONE_TO_LOW',
                '19': 'VERIFIED_TRANSITION_NONE_TO_UNKNOWN',
                '20': 'group_created',
                '21': 'group_subject_description_changed',
                '22': 'group_icon_changed',
                '23': 'group_invite_link_changed',
                '24': 'group_description_changed',
                '25': 'GROUP_CHANGE_RESTRICT',
                '26': 'GROUP_CHANGE_ANNOUNCE',
                '27': 'group_participant_added',
                '28': 'group_participant_removed',
                '29': 'GROUP_PARTICIPANT_PROMOTE',
                '30': 'GROUP_PARTICIPANT_DEMOTE',
                '31': 'group_participant_invited',
                '32': 'group_participant_left',
                '33': 'group_participant_number_changed',
                '34': 'BROADCAST_CREATE',
                '35': 'BROADCAST_ADD',
                '36': 'BROADCAST_REMOVE',
                '37': 'GENERIC_NOTIFICATION',
                '38': 'E2E_IDENTITY_CHANGED',
                '39': 'encrypt_enabled_for_conversation',
                '40': 'voice_call_lost',
                '41': 'video_call_lost',
                '42': 'INDIVIDUAL_CHANGE_NUMBER',
                '43': 'group_deleted',
                '44': 'GROUP_ANNOUNCE_MODE_MESSAGE_BOUNCE',
                '45': 'group_voice_call_lost',
                '46': 'group_video_call_lost',

                '47': 'PAYMENT_CIPHERTEXT',
                '48': 'PAYMENT_FUTUREPROOF',
                '49': 'PAYMENT_TRANSACTION_STATUS_UPDATE_FAILED',
                '50': 'PAYMENT_TRANSACTION_STATUS_UPDATE_REFUNDED',
                '51': 'PAYMENT_TRANSACTION_STATUS_UPDATE_REFUND_FAILED',
                '52': 'PAYMENT_TRANSACTION_STATUS_RECEIVER_PENDING_SETUP',
                '53': 'PAYMENT_TRANSACTION_STATUS_RECEIVER_SUCCESS_AFTER_HICCUP',
                '54': 'PAYMENT_ACTION_ACCOUNT_SETUP_REMINDER',
                '55': 'PAYMENT_ACTION_SEND_PAYMENT_REMINDER',
                '56': 'PAYMENT_ACTION_SEND_PAYMENT_INVITATION',
                '57': 'PAYMENT_ACTION_REQUEST_DECLINED',
                '58': 'PAYMENT_ACTION_REQUEST_EXPIRED',
                '59': 'PAYMENT_ACTION_REQUEST_CANCELLED',
                '60': 'BIZ_VERIFIED_TRANSITION_TOP_TO_BOTTOM',
                '61': 'BIZ_VERIFIED_TRANSITION_BOTTOM_TO_TOP',


                '62': 'you_are_chatting_with_a_business_account',
                '63': 'you_are_chatting_with_a_business_account',
                '64': 'BIZ_NAME_CHANGE',
                '65': 'this_account_is_now_registered_as_personal_account',

                '66': 'BIZ_TWO_TIER_MIGRATION_TOP',
                '67': 'BIZ_TWO_TIER_MIGRATION_BOTTOM',
                '68': 'OVERSIZED',
                '69': 'GROUP_CHANGE_NO_FREQUENTLY_FORWARDED',
                '70': 'GROUP_V4_ADD_INVITE_SENT',
                '71': 'GROUP_PARTICIPANT_ADD_REQUEST_JOIN',
                '72': 'CHANGE_EPHEMERAL_SETTING',

                '99': 'comercial_account_conversation',

                '100': 'oficial_account_conversation',
            };
        },

        data() {
            return {
                stubs: {}
            }
        },

        methods: {
            getStub(stubId) {
                return this.$t("stubs_" + this.stubs[stubId+'']);
            }
        }

        /*
        UNKNOWN = 0;
        REVOKE = 1;
        CIPHERTEXT = 2;
        FUTUREPROOF = 3;
        NON_VERIFIED_TRANSITION = 4;
        UNVERIFIED_TRANSITION = 5;
        VERIFIED_TRANSITION = 6;
        VERIFIED_LOW_UNKNOWN = 7;
        VERIFIED_HIGH = 8;
        VERIFIED_INITIAL_UNKNOWN = 9;
        VERIFIED_INITIAL_LOW = 10;
        VERIFIED_INITIAL_HIGH = 11;
        VERIFIED_TRANSITION_ANY_TO_NONE = 12;
        VERIFIED_TRANSITION_ANY_TO_HIGH = 13;
        VERIFIED_TRANSITION_HIGH_TO_LOW = 14;
        VERIFIED_TRANSITION_HIGH_TO_UNKNOWN = 15;
        VERIFIED_TRANSITION_UNKNOWN_TO_LOW = 16;
        VERIFIED_TRANSITION_LOW_TO_UNKNOWN = 17;
        VERIFIED_TRANSITION_NONE_TO_LOW = 18;
        VERIFIED_TRANSITION_NONE_TO_UNKNOWN = 19;
        GROUP_CREATE = 20;
        GROUP_CHANGE_SUBJECT = 21;
        GROUP_CHANGE_ICON = 22;
        GROUP_CHANGE_INVITE_LINK = 23;
        GROUP_CHANGE_DESCRIPTION = 24;
        GROUP_CHANGE_RESTRICT = 25;
        GROUP_CHANGE_ANNOUNCE = 26;
        GROUP_PARTICIPANT_ADD = 27;
        GROUP_PARTICIPANT_REMOVE = 28;
        GROUP_PARTICIPANT_PROMOTE = 29;
        GROUP_PARTICIPANT_DEMOTE = 30;
        GROUP_PARTICIPANT_INVITE = 31;
        GROUP_PARTICIPANT_LEAVE = 32;
        GROUP_PARTICIPANT_CHANGE_NUMBER = 33;
        BROADCAST_CREATE = 34;
        BROADCAST_ADD = 35;
        BROADCAST_REMOVE = 36;
        GENERIC_NOTIFICATION = 37;
        E2E_IDENTITY_CHANGED = 38;
        E2E_ENCRYPTED = 39;
        CALL_MISSED_VOICE = 40;
        CALL_MISSED_VIDEO = 41;
        INDIVIDUAL_CHANGE_NUMBER = 42;
        GROUP_DELETE = 43;
        GROUP_ANNOUNCE_MODE_MESSAGE_BOUNCE = 44;
        CALL_MISSED_GROUP_VOICE = 45;
        CALL_MISSED_GROUP_VIDEO = 46;
        PAYMENT_CIPHERTEXT = 47;
        PAYMENT_FUTUREPROOF = 48;
        PAYMENT_TRANSACTION_STATUS_UPDATE_FAILED = 49;
        PAYMENT_TRANSACTION_STATUS_UPDATE_REFUNDED = 50;
        PAYMENT_TRANSACTION_STATUS_UPDATE_REFUND_FAILED = 51;
        PAYMENT_TRANSACTION_STATUS_RECEIVER_PENDING_SETUP = 52;
        PAYMENT_TRANSACTION_STATUS_RECEIVER_SUCCESS_AFTER_HICCUP = 53;
        PAYMENT_ACTION_ACCOUNT_SETUP_REMINDER = 54;
        PAYMENT_ACTION_SEND_PAYMENT_REMINDER = 55;
        PAYMENT_ACTION_SEND_PAYMENT_INVITATION = 56;
        PAYMENT_ACTION_REQUEST_DECLINED = 57;
        PAYMENT_ACTION_REQUEST_EXPIRED = 58;
        PAYMENT_ACTION_REQUEST_CANCELLED = 59;
        BIZ_VERIFIED_TRANSITION_TOP_TO_BOTTOM = 60;
        BIZ_VERIFIED_TRANSITION_BOTTOM_TO_TOP = 61;
        BIZ_INTRO_TOP = 62;
        BIZ_INTRO_BOTTOM = 63;
        BIZ_NAME_CHANGE = 64;
        BIZ_MOVE_TO_CONSUMER_APP = 65;
        BIZ_TWO_TIER_MIGRATION_TOP = 66;
        BIZ_TWO_TIER_MIGRATION_BOTTOM = 67;
        OVERSIZED = 68;
        GROUP_CHANGE_NO_FREQUENTLY_FORWARDED = 69;
        GROUP_V4_ADD_INVITE_SENT = 70;
        GROUP_PARTICIPANT_ADD_REQUEST_JOIN = 71;
        CHANGE_EPHEMERAL_SETTING = 72;
         */

    }
</script>
